import apiClient from "./apiClient";

export function getDashboardStats() {
  return apiClient.get("/cars/dashboard-stats");
}

export function getMyCars() {
  return apiClient.get("/cars/my-cars");
}

export function addCar(payload) {
  return apiClient.post("/cars/add", payload);
}

export function getDefaultSeatLayout(carId) {
  return apiClient.get(`/cars/${carId}/default-seats`);
}

export function setCarSeats(carId, seats) {
  return apiClient.put(`/cars/${carId}/seats`, { seats });
}

export function publishCar(carId) {
  return apiClient.put(`/cars/${carId}/publish`);
}

export function addRoute(carId, payload) {
  return apiClient.post(`/routes/${carId}/add`, payload);
}

export function getCarById(carId) {
  return apiClient.get(`/cars/${carId}`);
}

export function updateCar(carId, payload) {
  return apiClient.put(`/cars/${carId}`, payload);
}

export function deleteCar(carId) {
  return apiClient.delete(`/cars/${carId}`);
}

// A car can now have multiple routes — this returns all of them.
export function getRoutesByCarId(carId) {
  return apiClient.get(`/routes/${carId}`);
}

export function updateRoute(routeId, payload) {
  return apiClient.put(`/routes/${routeId}/update`, payload);
}

export function deleteRoute(routeId) {
  return apiClient.delete(`/routes/${routeId}/delete`);
}

export function toggleRouteStatus(routeId) {
  return apiClient.put(`/routes/${routeId}/toggle-status`);
}

export function getCarStatus(carId) {
  return apiClient.get(`/cars/${carId}/status`);
}

export function searchRoutes({ fromCity, toCity, bookingType, travelDate }) {
  return apiClient.get("/routes/search", {
    params: { fromCity, toCity, bookingType, travelDate },
  });
}
